(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/components/tickets-wheel.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/components/tickets-wheel.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
let lastSnapped;
setGlobal('svs.tickets.play.components.TicketWheel', React.memo(_ref => {
  let accessibleText = _ref.accessibleText,
    children = _ref.children,
    onHandleNumberChanged = _ref.onHandleNumberChanged,
    handleGamePay = _ref.handleGamePay;
  const _React = React,
    useRef = _React.useRef,
    useState = _React.useState;
  const containerRef = useRef(null);
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeFocus = _useState2[0],
    setActiveFocus = _useState2[1];
  const selectSnappedElement = svs.tickets.play.utils.utils.selectSnappedElement;
  const lazySelected = _.debounce(checkSnapped, 10);
  return React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      handleGamePay();
    }
  }, React.createElement("div", {
    className: "ticket-wheel-container",
    onScroll: lazySelected,
    ref: containerRef
  }, React.createElement("div", {
    className: "ticket-wheel-fill-before"
  }), React.createElement("fieldset", {
    className: "ticket-wheel-fieldset"
  }, React.createElement("legend", {
    className: "ticket-wheel-legend"
  }, accessibleText), children.map((child, index) => {
    const _child$props = child.props,
      number = _child$props.number,
      chosen = _child$props.chosen;
    return React.createElement(React.Fragment, {
      key: index
    }, React.createElement("input", {
      "aria-label": "Lott ".concat(number, " av ").concat(children.length),
      checked: chosen,
      className: "qa-ticket-sunfeather-radio hide-radio",
      name: "ticket-skin-radio",
      onBlur: () => {
        setActiveFocus(null);
      },
      onChange: () => {
        onHandleNumberChanged(number);
      },
      onFocus: () => {
        setActiveFocus(number);
      },
      type: "radio",
      value: number
    }), React.createElement("label", {
      className: "wheel-item-wrapper",
      key: "wheel_child_".concat(index)
    }, React.cloneElement(child, {
      hasFocus: activeFocus === number
    })));
  })), React.createElement("input", {
    className: "qa-ticket-sunfeather-input",
    name: "submit-button",
    style: {
      opacity: 0,
      width: 0,
      height: 0
    },
    tabIndex: "-1",
    type: "submit"
  }), React.createElement("div", {
    className: "ticket-wheel-fill-after"
  })));

  function checkSnapped() {
    const selected = selectSnappedElement(containerRef.current, 'wheel-item-wrapper');
    if (selected && selected !== lastSnapped) {
      lastSnapped && lastSnapped.classList.remove('snapped');
      selected && selected.classList.add('snapped');
      lastSnapped = selected;
      onHandleNumberChanged(parseInt(selected.firstElementChild.dataset.ticketNumber, 10));
    }
  }
}));

 })(window);